export const isContentItem = (contentItem: any) => {
    return contentItem?.['metadata']?.['type'];
};
